module.exports = __webpack_public_path__ + "img/play.ff5420fb.png";